<template>
  <BaseInput
    :model-value="props.modelValue"
    :mask="MASK_OF_PHONE"
    inputmode="numeric"
    placeholder="+7 999-999-99-99"
    :with-full="props.withFull"
    :readonly="props.readonly"
    :with-readonly-icon="props.withReadonlyIcon"
    :variant="props.variant"
    @get-unmasked-value="handleChangeUnmaskedValue($event as string)"
    @click="handleClick"
    @click-append-icon="handleClickAppendIcon"
  />
</template>

<script setup lang="ts">
import { MASK_OF_PHONE } from '../../const/masks'
import { changeToCorrectNumber } from '../../lib/input/phone'
import { callPhone } from '../../lib/text/phone'
import BaseInput from '../input/index.vue'

interface Props {
  modelValue: string
  withFull?: boolean
  readonly?: boolean
  withCallAction?: boolean
  withReadonlyIcon?: boolean
  variant?: 'light' | 'secondary'
}

const props = withDefaults(defineProps<Props>(), {
  withCallAction: true,
  withReadonlyIcon: true,
})
const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
  (e: 'clickAppendIcon', name?: string): void
}>()

function handleChangeUnmaskedValue(value: string) {
  emit('update:modelValue', changeToCorrectNumber(value))
}

function handleClickAppendIcon(name?: string) {
  emit('clickAppendIcon', name)
}

function handleClick() {
  if (props.readonly && props.modelValue && props.withCallAction) {
    callPhone(props.modelValue)
  }
}
</script>
